import type { DeepPartial } from '@apollo/client/utilities';

import type { FootballFixture, TennisMatch } from '@swf/generated/graphql/scoreboards/schemas';

import { EventTypeId } from '../types/eventType';

export type ScoreboardData = DeepPartial<FootballFixture> | DeepPartial<TennisMatch>;

export const getIsFootballScoreboard = (
  eventTypeId: EventTypeId,
  _data: ScoreboardData
): _data is FootballFixture => eventTypeId === EventTypeId.SOCCER;

export const getIsTennisScoreboard = (
  eventTypeId: EventTypeId,
  _data: ScoreboardData
): _data is TennisMatch => eventTypeId === EventTypeId.TENNIS;
